import React from "react";
import { Row, Col, Form, Input, Button } from "antd";
import { Link } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import PublicHeader from "../../../layout/publicLayout/header";

import logo from "../../../assets/images/logo-skincare.png";

interface SignupComponentInterface {
  handleSignup?: any;
  submitting: boolean;
  registerErrors?: any;
  handleBackButton?: any
}

const SignupComponent: React.FC<SignupComponentInterface> = (props) => {
  const { handleSignup, submitting, registerErrors, handleBackButton } = props;

  return (
    <div className="auth-page">
      <PublicHeader />
      <div className="backButton">
        <Button
          icon={<ArrowLeftOutlined />}
          type="text"
          size="large"
          onClick={handleBackButton}
        />
      </div>
      <Row className="auth-page_row">
        <Col span={10} xs={20} sm={20} md={12} lg={8}>
          <div className="auth-form-wrapper">
            <h2>Sign up</h2>

            {/* <p>
              Create an account to access our features. There are list of
              products waiting for you recommended by us
            </p> */}

            <div className="auth-form auth-form--login">
              <Form
                name="login"
                layout="vertical"
                onFinish={(val) => {
                  handleSignup(val);
                }}
                autoComplete="off"
              >
                <Form.Item
                  label="Full Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please input your full name!" },
                  ]}
                  help={registerErrors?.name}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    { required: true, message: "Please input your email!" },
                    {
                      type: "email",
                      message: "Please input a valid email",
                    },
                  ]}
                  help={registerErrors?.email}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input a password!",
                    },
                    { min: 6 },
                  ]}
                  help={registerErrors?.password}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="password_confirmation"
                  label="Confirm New Password"
                  rules={[
                    {
                      required: true,
                      message: "Please input a password!",
                    },

                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          "The two passwords that you entered does not match."
                        );
                      },
                    }),
                  ]}
                  help={registerErrors?.password_confirmation}
                >
                  <Input.Password />
                </Form.Item>

                <Button
                  htmlType="submit"
                  className="btn-primary"
                  loading={submitting}
                  block
                >
                  Create your account
                </Button>
              </Form>
            </div>

            <div className="auth-page__forgotPassword">
              Already have an account? <Link to="/login">Log in</Link>
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignupComponent;
